const DEPARTMENTS_TABLE_READY = "departments-table-ready"
const SEARCH_TEXT_STATE = "departments-table-search-text-state"
const ROWS_PER_PAGE_STATE = "departments-table-rows-per-page-state"
const PAGINATION_STATE = "departments-table-pagination-state"

const DEPARTMENTS_ID_FOR_ACTION = "departments-table-brand-id-for-action"


const ADDEDIT_DEPARTMENTS_READY = "departments-table-addedit-departments-ready"

const initialState = {
    isDepartmentsTableReady: true,
    isAddEditDepartmentsReady: true,
    departments: {},

    
    departmentsSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case DEPARTMENTS_TABLE_READY:
            return Object.assign({}, state, { isDepartmentsTableReady: action.payload })

        case ADDEDIT_DEPARTMENTS_READY:
            return Object.assign({}, state, { isAddEditDepartmentsReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case DEPARTMENTS_ID_FOR_ACTION:
            return Object.assign({}, state, {departmentsSelectedId:action.payload})

        default:
        return state
    
    }

}

export function departmentsTableReady(data) {
    return {
        type: DEPARTMENTS_TABLE_READY,
        payload: data
    }
}

export function addEditDepartmentsReady(data) {
    return {
        type: ADDEDIT_DEPARTMENTS_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function departmentsIdForAction(departmentsId){
    return{
        type:DEPARTMENTS_ID_FOR_ACTION,
        payload:departmentsId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Departments/redux/departments.js